import { AdminPageCabecalhoComponent } from '../../shared/admin-page-cabecalho/admin-page-cabecalho.component';
import { Component, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
  CeiButtonComponent,
  CeiPanelComponent,
  CeiSnackBarService,
  CeiUserAvatarComponent,
} from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { DocumentoFiscalPipe } from '../../shared/documento-fiscal.pipe';
import { AdminPessoaUsuarioRecord, PessoaUsuarioApiService } from '../../services/pessoa-usuario-api.service';
import { parseRouteNumericId } from '../../shared/admin-record.utils';
import { notifyAdminListError } from '../../shared/admin-list.utils';

@Component({
  selector: 'cei-admin-detail',
  standalone: true,
  imports: [
    AdminPageCabecalhoComponent,
    RouterModule,
    CeiButtonComponent,
    CeiPanelComponent,
    CeiUserAvatarComponent,
    DocumentoFiscalPipe,
  ],
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.scss',
})
export class AdminDetailComponent {
  protected readonly record = signal<AdminPessoaUsuarioRecord | null>(null);
  private readonly api = inject(PessoaUsuarioApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly snackBar = inject(CeiSnackBarService);

  async ngOnInit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.route.paramMap.subscribe(async (params) => {
      const id = parseRouteNumericId(params.get('id'));
      if (!id) {
        this.record.set(null);
        return;
      }

      try {
        const data = await firstValueFrom(this.api.resolveAdminRecord(id));
        this.record.set(data);
      } catch (err) {
        notifyAdminListError(this.snackBar, 'Erro ao carregar registro.', err);
        this.record.set(null);
      }
    });
  }

  protected editLink(record: AdminPessoaUsuarioRecord): (string | number)[] {
    return ['/admin/pessoas/atualizar', record.pessoaId];
  }
}
